import type * as React from 'react'

import { cn } from '#app/utils/misc'

const Input = ({
	className,
	type,

	...props
}: React.ComponentProps<'input'>) => {
	return (
		<div>
			<input
				data-slot="input"
				type={type}
				className={cn(
					'ring-offset-background placeholder:text-muted-foreground flex h-10 w-full rounded-full border !border-[#CCCCCC] bg-[#FBFDFD] px-3 py-2 text-base file:border-0 file:bg-transparent file:text-base file:font-medium hover:!border-[#CCCCCC] focus:!border-[#CCCCCC] focus-visible:!border-[#CCCCCC] focus-visible:ring-0 focus-visible:outline-hidden disabled:cursor-not-allowed disabled:opacity-50 md:text-sm md:file:text-sm',
					// Invalid fields get a red outline in every state. The aria-[invalid]
					// variants carry higher specificity than the plain hover/focus rules
					// above, so red wins even though those are important.
					'aria-[invalid]:border-[#B33044]! aria-[invalid]:hover:border-[#B33044]! aria-[invalid]:focus:border-[#B33044]! aria-[invalid]:focus-visible:border-[#B33044]!',
					className,
				)}
				{...props}
			/>
		</div>
	)
}

export { Input }
